import React, { Component, Fragment } from "react";
import {
  Card,
  Badge,
  CardTitle,
  Row,
  Button,
  Input,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  CardBody,
  Table,
  Tooltip,
} from "reactstrap";
import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import { NotificationManager } from "../../../components/common/react-notifications";
import { Separator, Colxx } from "../../../components/common/CustomBootstrap";
import SingleLightbox from "../../../components/pages/SingleLightbox";
import IntlMessages from "../../../helpers/IntlMessages";
import GlideComponentCustom from "../../../components/carousel/GlideComponentCustom";import createSocket from "../../../helpers/createSocket";
import { END_POINT_SOCKET } from "../../../constants/defaultValues";
import smoothscroll from "smoothscroll-polyfill";
import { injectIntl } from "react-intl";
import {
  PageHeading,
  ThumbListViewMenuGuest,
  ProductOrderModalMenuGuest,
} from "../../../containers/pages/guest";
import PerfectScrollbar from "react-perfect-scrollbar";
import { NewMessage } from "../../../components/svg";
import MessageCard from "../../../containers/pages/message/MessageCardGuest";
import classnames from "classnames";
import {
  DEFAULT_COVER,
  getCompanyImage,
  AddCommaNumber,
  RandomNumber,
  getAvatar,
  getQrPayWithCash,
  NotificatioErrController,
} from "../../../helpers/Utils";
import STATUS from "../../../constants/status";
import CustomTooltip from "../../../components/CustomTooltip";
import { GetBank, SetBank } from "../../../helpers/ListBank";
import Select from "react-select";
import ProductImage from "../../../components/common/ProductImage";
import {
  getProductWithSingleOptionDefaults,
  isVariantSelectionComplete,
} from "../../../helpers/ProductOptionDefaults";
import {
  createOnlineMenuSearchParams,
  getOnlineMenuSearchErrorMessage,
  normalizeOnlineMenuSearch,
  ONLINE_MENU_SEARCH_DELAY,
} from "../../../helpers/OnlineMenuSearch";

const GetHashAndTableId = (path) => {
  const normalizeTableId = (value) => {
    const raw = `${value ?? ""}`.trim();
    if (!raw || raw === "null" || raw === "undefined") {
      return null;
    }
    return raw;
  };

  const normalizedPath = `${path ?? ""}`.trim();
  const splis = normalizedPath.split("-");

  let hash = normalizedPath;
  let table_id = null;

  if (splis.length > 1) {
    hash = splis[0];
    table_id = normalizeTableId(splis[1]);
  }

  return {
    hash,
    table_id,
  };
};

const HasTableId = (tableId) => {
  const raw = `${tableId ?? ""}`.trim();
  return raw !== "" && raw !== "null" && raw !== "undefined";
};

const GetCurrentTimeValue = () => {
  const now = new Date();
  const hour = `${now.getHours()}`.padStart(2, "0");
  const minute = `${now.getMinutes()}`.padStart(2, "0");
  return `${hour}:${minute}`;
};

const NormalizeDeliveryTime = (value) => {
  const raw = `${value ?? ""}`.trim();
  if (!raw) {
    return "";
  }

  const validTime = raw.match(/^([01]\d|2[0-3]):([0-5]\d)$/);
  if (validTime) {
    return raw;
  }

  const amPmMatch = raw.match(/^(\d{1,2}):([0-5]\d)\s*([aApP])[mM]?$/);
  if (amPmMatch) {
    let hour = parseInt(amPmMatch[1], 10);
    const minute = amPmMatch[2];
    const meridiem = amPmMatch[3].toLowerCase();

    if (hour === 12) {
      hour = meridiem === "a" ? 0 : 12;
    } else if (meridiem === "p") {
      hour += 12;
    }

    return `${`${hour}`.padStart(2, "0")}:${minute}`;
  }

  const digits = raw.replace(/\D/g, "").slice(0, 4);
  if (!digits) {
    return "";
  }

  if (digits.length <= 2) {
    return digits;
  }

  return `${digits.slice(0, 2)}:${digits.slice(2)}`;
};

smoothscroll.polyfill();

window.smoothScrollTo = function (endX, endY, duration) {
  let startX = window.scrollX || window.pageXOffset,
    startY = window.scrollY || window.pageYOffset,
    distanceX = endX - startX,
    distanceY = endY - startY,
    startTime = new Date().getTime();

  // Easing function
  let easeInOutQuart = function (time, from, distance, duration) {
    if ((time /= duration / 2) < 1)
      return (distance / 2) * time * time * time * time + from;
    return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
  };

  let timer = window.setInterval(function () {
    let time = new Date().getTime() - startTime,
      newX = easeInOutQuart(time, startX, distanceX, duration),
      newY = easeInOutQuart(time, startY, distanceY, duration);
    if (time >= duration) {
      window.clearInterval(timer);
    }
    window.scrollTo(newX, newY);
  }, 1000 / 60); // 60 fps
};

export class ProductGuest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTabDetail: false,
      messageInput: "",
      displayMode: "thumblist",

      categories: [],
      products: [],

      dropdownSplitOpen: false,
      categoryId: 0,
      search: "",
      items: [],
      isLoading: false,

      orders: [],
      orders_fr_server: [],
      ordersFiltered: [],
      modalOrderOpen: false,
      openMenu: false,
      openPayBill: false,
      store: window.location.host.split(".")[0],
      menu: GetHashAndTableId(props.location.pathname.split("/")[2]),
      table_identify: undefined,
      company: null,
      customer_phone: "",
      customer_name: "",
      customer_delivery_time: GetCurrentTimeValue(),
      customer_address: "",
      customerFormErrors: {},
      guest_require_customer_info: true,
      isVerify: true,
      startAt: 0,
      reMount: false,
      conversationData: [],
      didUpdate: false,
      isLoadedMore: false,
      isEndMessagesData: false,
      isFirstLoad: true,
      isCreatedAlert: false,
      dropDown: false,
      tooltipOpen: false,
      ipAddress: "",

      table_chair: {
        pin_id: undefined,
        id: undefined,
        floor: undefined,
        identify: undefined,
      },
      callServiceCooldown: 0, // Countdown timer for call service button
      callBellCooldown: 0, // Countdown timer for bell button
      selectedCustomerBank: { label: "Vietcombank", value: 970436 }, // Customer's bank selection for payment, default Vietcombank
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onToggleNote = this.onToggleNote.bind(this);
    this.listenToScroll = this.listenToScroll.bind(this);

    this.socket = createSocket();
    this.searchTimer = null;
    this.productRequestSequence = 0;
  }

  componentDidMount() {
    this.initGuestSession();

    this.socket.emit("join room", {
      room_id: localStorage.getItem("guest_session_id"),
    });

    this.socket.on("message get conversation guest", (res) => {
      const {
        data: { data, isEnd },
      } = res;

      this.setState({
        conversationData: data,
        didUpdate: false,
        isLoadedMore: true,
        isEndMessagesData: isEnd,
      });
    });

    this.socket.on("refresh-done-order", (res) => {
      if (this.hasTableOrderScope()) {
        this.getIdOrdersNow();
      }
    });

    this.socket.on("refresh-pending-order", (res) => {
      if (this.hasTableOrderScope()) {
        this.getIdOrdersNow();
      }
    });

    this.socket.on("refresh-created-order", (res) => {
      if (this.hasTableOrderScope()) {
        this.getIdOrdersNow();
      }
    });

    this.socket.on("refresh-refund-order", (res) => {
      if (this.hasTableOrderScope()) {
        this.getIdOrdersNow();
      }
    });

    this.socket.on("message new guest", (res) => {
      const { data } = res;
      if (data && data.length) {
        this.setState((prevState) => ({
          conversationData: [...(prevState.conversationData || []), ...data],
        }));
      }
    });

    Promise.all([
      this.isVerifyHashAndTime(),
      this.loadGuestStoreInformation(),
    ])
      .then(([verification, guestStore]) => {
        this.setupGuestSocketRooms(verification?.table_chair, guestStore);

        // working, loading data
        this.dataListRender();

        if (this.hasTableOrderScope()) {
          this.getIdOrdersNow();
        } else {
          this.setState({
            orders_fr_server: [],
            ordersFiltered: [],
          });
        }

        this.getIpAddress();
      })
      .catch(() => {
        this.dataListRender();
        this.getIpAddress();
      });

    window.addEventListener("scroll", this.listenToScroll);
  }

  hasTableOrderScope = () => {
    return HasTableId(this.state?.menu?.table_id);
  };

  componentWillUnmount() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
    this.productRequestSequence += 1;

    window.removeEventListener("scroll", this.listenToScroll);

    this.socket.close();
  }

  getIdOrdersNow = () => {
    if (!this.hasTableOrderScope()) {
      this.setState({
        orders_fr_server: [],
        ordersFiltered: [],
      });
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/order/all_orders_today"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then(async (data) => {
        // console.log('data_guest: ', data.data);
        this.setState((prev) => ({
          ...prev,
          orders_fr_server: data.data,
        }));
        this.filterOrdersByTableId();
      })
      .catch(() => {
        this.setState({
          orders_fr_server: [],
          ordersFiltered: [],
        });
      });
  };

  filterOrdersByTableId = async () => {
    if (!this.hasTableOrderScope()) {
      await this.setState((prev) => ({
        ...prev,
        ordersFiltered: [],
      }));
      return;
    }

    const { menu, orders_fr_server } = this.state;
    const menuTableId = Number(menu.table_id);
    if (Number.isNaN(menuTableId)) {
      await this.setState((prev) => ({
        ...prev,
        ordersFiltered: [],
      }));
      return;
    }

    const orders = orders_fr_server?.filter((order) => {
      return (
        Number(order.table_id) === menuTableId &&
        (order.status.uuid === 111 ||
          order.status.uuid === 222 ||
          order.status.uuid === 444)
      );
    });

    await this.setState((prev) => ({
      ...prev,
      ordersFiltered: this.consolidateOrders(orders),
    }));
  };

  consolidateOrders = (orders) => {
    const consolidatedOrders = {};

    orders.forEach((order) => {
      const key = `${order.product_id}-${order.time}-${order.status_id}-${order.ice}-${order.sugar}-${order.size}-${order.flavor}-${order.topping}`;

      if (!consolidatedOrders[key]) {
        consolidatedOrders[key] = {
          ...order,
          count: 1,
        };
      } else {
        consolidatedOrders[key].count += 1;
      }
    });

    return Object.values(consolidatedOrders);
  };

  listenToScroll() {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    let nav_items = document.getElementsByClassName("nav_items");
    if (nav_items.length < 1) return false;

    let item = null;
    let itemp = null;
    if (winScroll > 10 && winScroll <= 450) {
      for (itemp of nav_items) {
        itemp.classList.remove("active");
      }
      nav_items.item(0).classList.add("active");
    }

    if (winScroll > 450) {
      let offset = 90;

      let nav_len = nav_items.length;
      for (let i = 0; i < nav_len; i++) {
        let id = nav_items.item(i).id;
        item = document.getElementById("item_" + id);

        let posItem = item ? item.getBoundingClientRect().top : 0;
        if (posItem >= 0 && posItem <= offset) {
          // active item
          for (itemp of nav_items) {
            itemp.classList.remove("active");
          }

          nav_items.item(i).classList.add("active");

          // startAt glide
          if (nav_len <= 3 || i === 0 || i === 1) {
            this.setState({ startAt: 0 });
          } else if (i < nav_len - 1) {
            this.setState({ reMount: true, startAt: i - 1 });
          }
        }

        // you're at the bottom of the page
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
          for (itemp of nav_items) {
            itemp.classList.remove("active");
          }

          nav_items.item(nav_len - 1).classList.add("active");
        }
        // console.log(id, item.getBoundingClientRect().top, window.innerHeight)
      }
    }
  }

  isVerifyHashAndTime() {
    let {
      store,
      menu: { hash, table_id },
    } = this.state;

    return axios
      .get(
        `${
          END_POINT + "/product/guest/verify"
        }?store=${store}&hash=${hash}&tableId=${table_id}`,
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if (!data.data) {
          this.setState({ isVerify: false });
        } else {
          const { table_chair } = data;

          if (table_chair) {
            const { id, floor, identify } = table_chair;

            this.setState((prev) => ({
              isVerify: true,
              table_chair: {
                ...prev.table_chair,
                floor,
                identify,
                id,
                pin_id: `${RandomNumber(5)}`,
              },
            }));
          } else {
            // Remote menu mode: valid hash + store without table scope
            this.setState({
              isVerify: true,
              table_chair: {
                pin_id: undefined,
                id: undefined,
                floor: undefined,
                identify: undefined,
              },
            });
          }
        }
        return data;
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isVerify: false });
      });
  }

  offset(el) {
    let rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
  }

  scrollToMyRef(e) {
    // document.getElementById('item_' + e.target.id).scrollIntoView({
    //   behavior: 'smooth',
    // });

    let pos = this.offset(document.getElementById("item_" + e.target.id));
    if ("scrollBehavior" in document.documentElement.style) {
      //Checks if browser supports scroll function
      window.scroll({
        top: pos.top - 50,
        left: 0,
        behavior: "smooth",
      });
    } else {
      // window.smoothScrollTo(0, pos, 500); //polyfill below
      document.getElementById("item_" + e.target.id).scrollIntoView({
        behavior: "smooth",
      });
    }
  }

  renderCategories() {
    return this.state.items.map((categories, index) => (
      <p
        onClick={(e) => {
          this.scrollToMyRef(e);
        }}
        key={categories.id}
        id={index}
        className="nav_items cursor-pointer"
      >
        {categories.name}
      </p>
    ));
  }

  onSearchKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.scheduleProductSearch(e.target.value, true);
    }
  };

  onSearchChange = (e) => {
    this.scheduleProductSearch(e.target.value);
  };

  scheduleProductSearch = (value, immediate = false) => {
    const search = normalizeOnlineMenuSearch(value);

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }

    this.setState(
      {
        search,
      },
      () => {
        if (immediate) {
          this.dataListRender();
          return;
        }

        this.searchTimer = setTimeout(() => {
          this.searchTimer = null;
          this.dataListRender();
        }, ONLINE_MENU_SEARCH_DELAY);
      },
    );
  };

  dataListRender() {
    const { categoryId, search, store } = this.state;
    if (!store) return false;

    const requestSequence = ++this.productRequestSequence;

    axios
      .get(END_POINT + "/product/guest", {
        params: createOnlineMenuSearchParams({ store, categoryId, search }),
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        if (requestSequence !== this.productRequestSequence) return;

        let menu = [];

        // best seller - goi y mon ngon
        let template = {
          id: 0,
          name: "Khuyên dùng",
          data: data.data.filter((p) => !!p.bestter),
        };

        if (template.data.length > 0) {
          menu.push(template);
        }

        // group by category
        let category_id = [];
        data.data
          .filter((p) => !p.bestter)
          .forEach((p) => {
            if (!category_id.includes(p.category.id)) {
              category_id.push(p.category.id);

              template = {
                id: p.category.id,
                name: p.category.name,
                data: [],
              };
              template.data.push(p);
              menu.push(template);
            } else {
              menu.forEach((m) => {
                if (p.category.id === m.id) {
                  m.data.push(p);
                }
              });
            }
          });

        this.setState({
          totalPage: data.totalPage,
          items: menu,
          totalItemCount: data.totalItem,
          isLoading: true,
          startAt: 0,
        });
      })
      .catch((err) => {
        if (requestSequence !== this.productRequestSequence) return;

        const { messages } = this.props.intl;
        NotificationManager.error(
          getOnlineMenuSearchErrorMessage(err),
          messages["general.error.title"],
          3000,
          null,
          null,
          "filled",
        );
        return false;
      });
  }

  getUserInformation() {
    return axios
      .get(END_POINT + "/user/guest/store", {
        params: { store: this.state.store },
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  }

  loadGuestStoreInformation = () => {
    return this.getUserInformation().then((response) => {
      const guestStore = response?.data;
      if (!guestStore) return;

      const guestRequireCustomerInfo =
        guestStore.guest_require_customer_info !== false;

      if (guestStore.user_id) {
        localStorage.setItem("user_id", guestStore.user_id);
        this.socket.emit("join room", {
          room_id: guestStore.user_id,
        });
      }

      this.setState({
        company: guestStore,
        guest_require_customer_info: guestRequireCustomerInfo,
      });
      document.title = "Menu - " + guestStore.companyName;
      return guestStore;
    });
  };

  setupGuestSocketRooms = (tableChair, guestStore) => {
    const userId = guestStore?.user_id || localStorage.getItem("user_id");
    if (!userId || !this.hasTableOrderScope()) return;

    const activeTableChair = tableChair || this.state.table_chair;
    const { id, pin_id } = activeTableChair || {};
    if (id === undefined || pin_id === undefined) return;

    this.socket.emit("join room", {
      room_id: `${pin_id}.${id}`,
    });
    this.socket.emit("message get conversation guest", {
      user_id: userId,
      pin_id,
      sender_id: pin_id,
      table_chair_id: id,
    });
  };

  normalizeOptionValue = (option) => {
    if (option && typeof option === "object") {
      return option.value;
    }
    return option;
  };

  getDefaultPercentOptionValue = (options = [], fallbackValue = "100") => {
    if (!Array.isArray(options) || !options.length) {
      return fallbackValue;
    }

    const optionWithHundred = options.find(
      (option) => `${this.normalizeOptionValue(option)}` === "100",
    );

    if (optionWithHundred !== undefined) {
      return this.normalizeOptionValue(optionWithHundred);
    }

    return this.normalizeOptionValue(options[0]);
  };

  buildResetOptionFields = (product) => {
    const resetFields = {
      sizeSelectedId: [],
      flavorSelectedId: [],
      toppingSelectedId: [],
      selectedAttributes: {},
      note: "",
    };

    if (Array.isArray(product?.ice) && product.ice.length) {
      resetFields.iceSelectedValue = this.getDefaultPercentOptionValue(
        product.ice,
        product.iceSelectedValue || "100",
      );
    }

    if (Array.isArray(product?.sugar) && product.sugar.length) {
      resetFields.sugarSelectedValue = this.getDefaultPercentOptionValue(
        product.sugar,
        product.sugarSelectedValue || "100",
      );
    }

    return resetFields;
  };

  resetProductOptionsInItems = (items = [], productId) => {
    const nextItems = items.map((category) => {
      if (!Array.isArray(category?.data) || !category.data.length) {
        return category;
      }

      const nextData = category.data.map((item) => {
        if (item.id !== productId) return item;
        return {
          ...item,
          ...this.buildResetOptionFields(item),
        };
      });

      return {
        ...category,
        data: nextData,
      };
    });

    return nextItems;
  };

  resetProductOptionsInState = (productId) => {
    this.setState((prev) => ({
      items: this.resetProductOptionsInItems(prev.items, productId),
    }));
  };

  normalizeSelectedIds = (ids = []) => {
    if (!Array.isArray(ids)) {
      return [];
    }

    return ids.map((id) => `${id}`).sort();
  };

  normalizeNoteValue = (note) => `${note || ""}`.trim();

  normalizeSelectedAttributes = (selectedAttributes = {}) =>
    Object.keys(selectedAttributes)
      .sort()
      .map(
        (key) =>
          `${key}:${selectedAttributes[key]?.value ?? ""}`,
      )
      .join("|");

  buildOrderSignature = (orderLike = {}) => {
    const productId =
      orderLike.id !== undefined ? orderLike.id : orderLike.product_id;

    return [
      `${productId ?? ""}`,
      `${orderLike.priceType || "retail"}`,
      this.normalizeSelectedIds(orderLike.sizeSelectedId).join("|"),
      this.normalizeSelectedIds(orderLike.flavorSelectedId).join("|"),
      this.normalizeSelectedIds(orderLike.toppingSelectedId).join("|"),
      `${orderLike.iceSelectedValue ?? ""}`,
      `${orderLike.sugarSelectedValue ?? ""}`,
      this.normalizeSelectedAttributes(orderLike.selectedAttributes),
      this.normalizeNoteValue(orderLike.note),
    ].join("::");
  };

  buildOrderLineFromProduct = ({ product, count = 1, price }) => ({
    id: product.id,
    name: product.name,
    price,
    priceType: product.priceType || "retail",
    count,
    note: this.normalizeNoteValue(product.note),
    iceSelectedValue: product.iceSelectedValue,
    sugarSelectedValue: product.sugarSelectedValue,
    sizeSelectedId: Array.isArray(product.sizeSelectedId)
      ? [...product.sizeSelectedId]
      : [],
    flavorSelectedId: Array.isArray(product.flavorSelectedId)
      ? [...product.flavorSelectedId]
      : [],
    toppingSelectedId: Array.isArray(product.toppingSelectedId)
      ? [...product.toppingSelectedId]
      : [],
    selectedAttributes: { ...(product.selectedAttributes || {}) },
    previewDisplay: false,
  });

  findOrderIndexBySignature = (orders = [], orderLike = {}) => {
    const targetSignature = this.buildOrderSignature(orderLike);
    return orders.findIndex(
      (order) => this.buildOrderSignature(order) === targetSignature,
    );
  };

  // ORDER
  toggleModalOrder = () => {
    this.setState({
      modalOrderOpen: !this.state.modalOrderOpen,
    });
  };

  calculateProductPrice = (product) => {
    let price;
    const bt = String(product.business_type || "").toLowerCase().trim();
    const isFnB = bt === "cafe" || bt === "restaurant";

    if (!isFnB && product.priceType === "wholesale") {
      price = parseFloat(product.price_wholesale) || 0;
    } else {
      price =
        product.active_sale && parseFloat(product.price_sale) > 0
          ? product.price_sale
          : product.price;
    }

    if (product.sizeSelectedId?.length) {
      const find_size = product.size?.find((_size) =>
        product.sizeSelectedId.includes(_size.id),
      );
      if (find_size) {
        price =
          parseFloat(find_size.promo_price) > 0
            ? parseFloat(find_size.promo_price)
            : parseFloat(find_size.value) || parseFloat(price) || 0;
      }
    }

    if (product.flavorSelectedId?.length) {
      const findFlavor = product.flavor?.find((flavor) =>
        product.flavorSelectedId.includes(flavor.id),
      );
      if (findFlavor) {
        const flavorPrice =
          parseFloat(findFlavor.promo_price) > 0
            ? parseFloat(findFlavor.promo_price)
            : parseFloat(findFlavor.value) || 0;
        price = parseFloat(price) + flavorPrice;
      }
    }

    if (product.toppingSelectedId?.length) {
      const find_topping = product.topping?.filter((_size) =>
        product.toppingSelectedId.includes(_size.id),
      );

      for (let i = 0; i < find_topping.length; i++) {
        const toppingPrice =
          parseFloat(find_topping[i].promo_price) > 0
            ? parseFloat(find_topping[i].promo_price)
            : parseFloat(find_topping[i].value) || 0;
        price = parseFloat(price) + toppingPrice;
      }
    }

    return price;
  };

  hasMissingRequiredSize = (product) =>
    Array.isArray(product?.size) &&
    product.size.length > 0 &&
    (!Array.isArray(product.sizeSelectedId) ||
      product.sizeSelectedId.length === 0);

  hasMissingRequiredFlavor = (product) =>
    Array.isArray(product?.flavor) &&
    product.flavor.length > 0 &&
    (!Array.isArray(product.flavorSelectedId) ||
      product.flavorSelectedId.length === 0);

  addToCartWithQuantity = ({ product, quantity }) => {
    if (!isVariantSelectionComplete(product)) {
      return false;
    }

    if (this.hasMissingRequiredSize(product)) {
      NotificationManager.warning("Vui lòng chọn kích thước trước khi gọi món");
      return false;
    }

    if (this.hasMissingRequiredFlavor(product)) {
      NotificationManager.warning("Vui lòng chọn vị trước khi gọi món");
      return false;
    }

    const parsedQuantity = parseInt(quantity, 10);
    const quantityToAdd =
      Number.isNaN(parsedQuantity) || parsedQuantity < 1 ? 1 : parsedQuantity;
    const unitPrice = this.calculateProductPrice(product);
    const orderLine = this.buildOrderLineFromProduct({
      product,
      count: quantityToAdd,
      price: unitPrice,
    });

    this.setState(
      (prev) => {
        const matchedOrderIndex = this.findOrderIndexBySignature(
          prev.orders,
          orderLine,
        );

        if (matchedOrderIndex >= 0) {
          const nextOrders = prev.orders.map((order, index) =>
            index === matchedOrderIndex
              ? {
                  ...order,
                  count: order.count + quantityToAdd,
                  price: unitPrice,
                  note: orderLine.note,
                  iceSelectedValue: orderLine.iceSelectedValue,
                  sugarSelectedValue: orderLine.sugarSelectedValue,
                  sizeSelectedId: orderLine.sizeSelectedId,
                  flavorSelectedId: orderLine.flavorSelectedId,
                  toppingSelectedId: orderLine.toppingSelectedId,
                  selectedAttributes: orderLine.selectedAttributes,
                }
              : order,
          );

          return {
            orders: nextOrders,
          };
        }

        return {
          orders: [...prev.orders, orderLine],
        };
      },
      () => {
        this.resetProductOptionsInState(product.id);
      },
    );
  };

  updateOrders = ({ product, requireCreated = false }) => {
    if (requireCreated && !isVariantSelectionComplete(product)) {
      product.detailDisplay = true;
      this.setState((prev) => ({ ...prev }));
      return false;
    }

    if (requireCreated && this.hasMissingRequiredSize(product)) {
      NotificationManager.warning("Vui lòng chọn kích thước trước khi gọi món");
      product.detailDisplay = true;
      this.setState((prev) => ({ ...prev }));
      return false;
    }

    if (requireCreated && this.hasMissingRequiredFlavor(product)) {
      NotificationManager.warning("Vui lòng chọn vị trước khi gọi món");
      product.detailDisplay = true;
      this.setState((prev) => ({ ...prev }));
      return false;
    }

    const price = this.calculateProductPrice(product);
    const orderLine = this.buildOrderLineFromProduct({
      product,
      count: 1,
      price,
    });

    this.setState((prev) => {
      const matchedOrderIndex = this.findOrderIndexBySignature(
        prev.orders,
        orderLine,
      );

      if (matchedOrderIndex >= 0) {
        const orders = prev.orders.map((order, index) =>
          index === matchedOrderIndex
            ? {
                ...order,
                price,
                note: orderLine.note,
                iceSelectedValue: orderLine.iceSelectedValue,
                sugarSelectedValue: orderLine.sugarSelectedValue,
                sizeSelectedId: orderLine.sizeSelectedId,
                flavorSelectedId: orderLine.flavorSelectedId,
                toppingSelectedId: orderLine.toppingSelectedId,
              }
            : order,
        );
        return { orders };
      }

      if (requireCreated) {
        return { orders: [...prev.orders, orderLine] };
      }

      return null;
    });
  };

  getPreferredLocalOrderIndex = (productId, orders = this.state.orders) => {
    const product = this.getProductInfo(productId);

    if (product) {
      const currentSelection = this.buildOrderLineFromProduct({
        product,
        count: 1,
        price: 0,
      });
      const matchedIndex = this.findOrderIndexBySignature(
        orders,
        currentSelection,
      );

      if (matchedIndex >= 0) {
        return matchedIndex;
      }
    }

    return -1;
  };

  plus = (id) => {
    const localOrderIndex = this.getPreferredLocalOrderIndex(id);

    if (localOrderIndex < 0) {
      const product = this.getProductInfo(id);
      if (!product) return false;

      this.updateOrders({ product, requireCreated: true });
      return;
    }

    this.setState((prev) => ({
      orders: prev.orders.map((order, index) =>
        index === localOrderIndex ? { ...order, count: order.count + 1 } : order,
      ),
    }));
  };

  sub = (id) => {
    const localOrderIndex = this.getPreferredLocalOrderIndex(id);

    if (localOrderIndex >= 0) {
      this.setState((prev) => ({
        orders: prev.orders
          .map((order, index) =>
            index === localOrderIndex
              ? { ...order, count: order.count - 1 >= 0 ? order.count - 1 : 0 }
              : order,
          )
          .filter((order) => order.count > 0),
      }));
      return;
    }

    // Check server orders (ordersFiltered) - only allow decrease for status 111
    const serverOrders =
      this.state.ordersFiltered?.filter((order) => order.product_id === id) ||
      [];

    if (serverOrders.length > 0) {
      // Check if any server order has status other than 111 (pending)
      const hasNonPendingOrder = serverOrders.some(
        (order) => order.status?.uuid !== 111,
      );

      if (hasNonPendingOrder) {
        // Cannot decrease - order is already being processed (222) or delivered (444)
        console.log("Không thể giảm món đã được xác nhận hoặc đang chế biến");
        return false;
      }

      // TODO: If needed, implement server-side decrease for status 111 orders
      // For now, we just prevent the action as we don't have API to modify server orders
      console.log("Món từ server với status 111 - cần API để giảm");
      return false;
    }

    return false;
  };
  change = (e, id) => {
    if (!e || !e.target) return false;

    let { value } = e.target;
    const parsedValue = parseInt(value, 10);
    const nextCount = Number.isNaN(parsedValue) ? 0 : parsedValue;
    const localOrderIndex = this.getPreferredLocalOrderIndex(id);

    if (localOrderIndex < 0) {
      const product = this.getProductInfo(id);
      if (!product) return false;

      this.updateOrders({ product, requireCreated: true });
      return;
    }

    this.setState((prev) => ({
      orders: prev.orders
        .map((order, index) =>
          index === localOrderIndex
            ? { ...order, count: nextCount >= 0 ? nextCount : 0 }
            : order,
        )
        .filter((order) => order.count > 0),
    }));
  };

  onChange = (e) => {
    if (e.target) {
      const {
        target: { name, value },
      } = e;
      const nextValue =
        name === "customer_delivery_time"
          ? NormalizeDeliveryTime(value)
          : value;

      this.setState((prev) => ({
        ...prev,
        [name]: nextValue,
        customerFormErrors: {
          ...prev.customerFormErrors,
          [name]: "",
        },
      }));
    } else {
    }
  };

  onToggleNote(id) {
    const orders = this.state.orders.map((o) =>
      o.id === id ? { ...o, noteDisplay: !o.noteDisplay } : o,
    );

    this.setState({ orders });
  }

  onRemoveOrder = (orderOrId) => {
    if (orderOrId && typeof orderOrId === "object") {
      const targetIndex = this.findOrderIndexBySignature(
        this.state.orders,
        orderOrId,
      );

      if (targetIndex >= 0) {
        this.setState((prev) => ({
          orders: prev.orders.filter((_, index) => index !== targetIndex),
        }));
        return;
      }
    }

    const targetId =
      orderOrId && typeof orderOrId === "object" ? orderOrId.id : orderOrId;
    this.setState((prev) => ({
      orders: prev.orders.filter((_order) => _order.id !== targetId),
    }));
  };

  onToggleDetail = ({ product, name, value }) => {
    // console.log('product: ', product);
    // console.log('name: ', name);
    // console.log('value: ', value);
    const products = this.state.items;
    // console.log('products: ', products);
    let find_product = products.map((categories) =>
      categories.data.find(
        (_product) => _product.id === product.id && !_product.softHide,
      ),
    );

    if (find_product) {
      find_product = find_product.find(function (el) {
        return el != null;
      });
    }

    if (find_product) {
      // toggle hiển thị hoặc không
      if (name === "detailDisplay") {
        find_product[name] = !find_product[name];
        if (find_product[name]) {
          Object.assign(
            find_product,
            getProductWithSingleOptionDefaults(find_product),
          );
        }

        this.setState((prev) => ({
          ...prev,
          items: products,
        }));

        // console.log('items: ', this.state.items);
      } else if (name === "orderDisplay") {
        if (!isVariantSelectionComplete(find_product)) {
          find_product.detailDisplay = true;
          this.setState((prev) => ({ ...prev, items: products }));
          return false;
        }

        if (this.hasMissingRequiredSize(find_product)) {
          NotificationManager.warning("Vui lòng chọn kích thước trước khi gọi món");
          find_product.detailDisplay = true;
          this.setState((prev) => ({ ...prev, items: products }));
          return false;
        }

        if (this.hasMissingRequiredFlavor(find_product)) {
          NotificationManager.warning("Vui lòng chọn vị trước khi gọi món");
          find_product.detailDisplay = true;
          this.setState((prev) => ({ ...prev, items: products }));
          return false;
        }

        const productForOrder = {
          ...find_product,
          sizeSelectedId: Array.isArray(find_product.sizeSelectedId)
            ? [...find_product.sizeSelectedId]
            : [],
          flavorSelectedId: Array.isArray(find_product.flavorSelectedId)
            ? [...find_product.flavorSelectedId]
            : [],
          toppingSelectedId: Array.isArray(find_product.toppingSelectedId)
            ? [...find_product.toppingSelectedId]
            : [],
        };

        find_product[name] = !find_product[name];

        this.setState(
          (prev) => ({
            ...prev,
            items: products,
          }),
          () => {
            this.updateOrders({
              product: productForOrder,
              requireCreated: true,
            });
            this.resetProductOptionsInState(product.id);
          },
        );
      }

      // check vào các giá trị size, topping, ice, sugar
      else {
        if (name === "variantSelection") {
          const updatedProducts = products.map((category) => ({
            ...category,
            data: category.data.map((item) =>
              item.id === find_product.id ? value : item,
            ),
          }));

          this.setState((prev) => ({
            ...prev,
            items: updatedProducts,
          }));
          return;
        }

        let _value = value;

        // size và topping thì cho mảng các giá trị
        // Vì Topping thì có thể mix nhiều loại
        // Size thì luôn luôn required 1 loại
        if (
          name === "sizeSelectedId" ||
          name === "flavorSelectedId" ||
          name === "toppingSelectedId"
        ) {
          if (name === "sizeSelectedId" || name === "flavorSelectedId") {
            _value = [_value];
          } else if (find_product[name]?.includes(value)) {
            _value = find_product[name].filter((_item) => _item !== value);
          } else if (name === "toppingSelectedId") {
            _value = [...(find_product[name] || []), _value];
          }
        }

        const updatedProduct = {
          ...find_product,
          [name]: _value,
        };

        if (name === "sizeSelectedId") {
          const selectedId = _value[0];
          if (selectedId) {
            const selectedItem = find_product.size?.find((item) => item.id === selectedId);
            if (selectedItem) {
              updatedProduct.sizeName = selectedItem.name;
              updatedProduct.sizeValue = Number(selectedItem.value);
            }
          } else {
            updatedProduct.sizeName = undefined;
            updatedProduct.sizeValue = undefined;
          }
        } else if (name === "flavorSelectedId") {
          const selectedId = _value[0];
          if (selectedId) {
            const selectedItem = find_product.flavor?.find((item) => item.id === selectedId);
            if (selectedItem) {
              updatedProduct.flavorName = selectedItem.name;
              updatedProduct.flavorValue =
                parseFloat(selectedItem.promo_price) > 0
                  ? selectedItem.promo_price
                  : selectedItem.value;
            }
          } else {
            updatedProduct.flavorName = undefined;
            updatedProduct.flavorValue = undefined;
          }
        } else if (name === "toppingSelectedId") {
          const selectedToppings = (_value || [])
            .map((id) => find_product.topping?.find((item) => item.id === id))
            .filter(Boolean);
          updatedProduct.toppingName = selectedToppings.map((item) => item.name);
          updatedProduct.toppingValue = selectedToppings.map((item) =>
            parseFloat(item.promo_price) > 0 ? item.promo_price : item.value
          );
        }

        const updatedProducts = products.map((category) => ({
          ...category,
          data: category.data.map((item) =>
            item.id === updatedProduct.id ? updatedProduct : item,
          ),
        }));

        this.setState(
          (prev) => ({
            ...prev,
            items: updatedProducts,
          }),
          () => this.updateOrders({ product: updatedProduct }),
        );
      }
    }
  };

  handleSubmit() {
    const { messages } = this.props.intl;
    console.log("orders: ", this.state.orders);
    if (this.state.orders.length < 1) {
      NotificationManager.error(
        messages["home.notify.no-products"],
        messages["general.error.title"],
        3000,
        null,
        null,
        "filled",
      );
      return false;
    }

    const customerName = (this.state.customer_name || "").trim();
    const customerPhone = (this.state.customer_phone || "").trim();
    const customerDeliveryTime = NormalizeDeliveryTime(
      this.state.customer_delivery_time,
    );
    const customerAddress = (this.state.customer_address || "").trim();
    const isTableOrder = this.hasTableOrderScope();
    const isValidDeliveryTime = /^([01]\d|2[0-3]):([0-5]\d)$/.test(
      customerDeliveryTime,
    );

    const customerFormErrors = {};

    if (!customerPhone) {
      customerFormErrors.customer_phone = "Vui lòng nhập số điện thoại";
    }

    if (!isTableOrder && !customerName) {
      customerFormErrors.customer_name = "Vui lòng nhập tên khách hàng";
    }

    if (!isTableOrder && !customerDeliveryTime) {
      customerFormErrors.customer_delivery_time = "Vui lòng nhập giờ giao";
    }

    if (!isTableOrder && !customerAddress) {
      customerFormErrors.customer_address = "Vui lòng nhập địa chỉ";
    }

    if (!isTableOrder && customerDeliveryTime && !isValidDeliveryTime) {
      customerFormErrors.customer_delivery_time =
        "Giờ giao không hợp lệ, vui lòng nhập theo định dạng HH:mm";
    }

    if (Object.values(customerFormErrors).some(Boolean)) {
      this.setState({ customerFormErrors });
      NotificationManager.error(
        "Vui lòng kiểm tra các thông tin còn thiếu",
        messages["general.error.title"],
        3000,
        null,
        null,
        "filled",
      );
      return false;
    }

    this.setState({ customerFormErrors: {} });

    // axios submit
    axios
      .post(`${END_POINT + "/bill/guest"}`, {
        data: this.state.orders,
        store: this.state.store,
        phone: customerPhone,
        name: customerName,
        delivery_time: customerDeliveryTime,
        customer_address: customerAddress,
        hash: this.state.menu.hash || "",
        table_id: this.hasTableOrderScope() ? this.state.menu.table_id : null,
      })
      .then((res) => {
        // console.log('res: ', res.data);
        return res.data;
      })
      .then((data) => {
        NotificationManager.primary(
          data.responseText,
          "",
          3000,
          null,
          null,
          "filled",
        );

        const { bill_id } = data;

        // real-time
        this.socket.emit("refresh-bestseller", {
          user_id: localStorage.getItem("user_id"),
          type: localStorage.getItem("selectedDropdownBestSeller"),
        });
        this.socket.emit("refresh-recent-order", {
          user_id: localStorage.getItem("user_id"),
          floor: 0,
          table_id: this.hasTableOrderScope() ? this.state.menu.table_id : "",
        });
        this.socket.emit("refresh-pending-order", {
          user_id: localStorage.getItem("user_id"),
        });
        this.socket.emit("refresh-done-order", {
          user_id: localStorage.getItem("user_id"),
        });
        this.socket.emit("refresh-refund-order", {
          user_id: localStorage.getItem("user_id"),
        });

        // refresh alert data
        this.socket.emit("refresh-alert-data", {
          user_id: localStorage.getItem("user_id"),
        });

        // re-mind order after 2 minutes
        this.socket.emit("remind-created-orders", {
          data: this.state.orders,
          user_id: localStorage.getItem("user_id"),
          bill_id,
        });

        this.setState({
          orders: [],
          orderCount: 1,
          orderProduct: "",
          customer_delivery_time: GetCurrentTimeValue(),
          customerFormErrors: {},
          modalOrderOpen: !this.state.modalOrderOpen,
          openMenu: false,
        });

        this.getIdOrdersNow();
        // this.renderOrders();
      })
      .catch((err) => {
        NotificationManager.error(
          err.response.data.responseText,
          "Lỗi !",
          3000,
          null,
          null,
          "filled",
        );
      });
  }
  // END ORDER

  getOrder(id) {
    const localOrders = this.state.orders.filter((order) => order.id === id);
    const localOrderCount = localOrders.reduce(
      (sum, order) => sum + (order.count || 0),
      0,
    );
    const localOrder = localOrders.length ? localOrders[0] : null;

    // Get order from server (ordersFiltered) - uses product_id instead of id
    const serverOrders =
      this.state.ordersFiltered?.filter((order) => order.product_id === id) ||
      [];
    const serverOrderCount = serverOrders.reduce(
      (sum, order) => sum + (order.count || 1),
      0,
    );

    // If we have orders from server but not local, create a virtual order object
    if (serverOrderCount > 0 && !localOrderCount) {
      return {
        id: id,
        count: serverOrderCount,
        isFromServer: true, // Flag to indicate this is from server
      };
    }

    if (localOrder && (localOrderCount > 0 || serverOrderCount > 0)) {
      return {
        ...localOrder,
        count: localOrderCount + serverOrderCount,
      };
    }

    return null;
  }
  getProductInfo(id) {
    const products = this.state.items
      .map((categories) =>
        categories.data.filter((product) => product.id === id),
      )
      .filter((items) => items.length > 0);

    return products.length > 0 ? products[0][0] : null;
  }

  calTotalPrice = (orders) => {
    let total = 0;
    for (let i = 0; i < orders.length; i++) {
      let order = orders[i];

      total += parseInt(order.price) * order.count;
    }
    return total;
  };

  calcNumberOrder = (orders) => {
    let sum = 0;
    let i = 0;
    let orders_len = orders.length;
    let order = null;
    for (; i < orders_len; i++) {
      order = orders[i];
      sum += order.count;
    }
    return sum;
  };

  initGuestSession = () => {
    let userId = localStorage.getItem("guest_session_id");
    if (!userId || userId === "null" || userId === "undefined") {
      // Generate a simple UUID-like string
      userId =
        "guest_" + Math.random().toString(36).substr(2, 9) + "_" + Date.now();
      localStorage.setItem("guest_session_id", userId);
      console.log("[GuestSession] Generated new Guest ID:", userId);
    } else {
      console.log("[GuestSession] Restored existing Guest ID:", userId);
    }
  };

  /**
   * New Message
   */
  handleGetConversation = () => {
    if (!this.hasTableOrderScope()) {
      return;
    }

    let offset = 0;
    if (this.state.conversationData) {
      offset = this.state.conversationData.length;
    }

    const { id, pin_id } = this.state.table_chair;
    if (id === undefined || pin_id === undefined) {
      return;
    }

    this.socket.emit("message get conversation guest", {
      user_id: localStorage.getItem("guest_session_id"),
      pin_id,
      table_chair_id: id,
      sender_id: localStorage.getItem("guest_session_id"),
      offset,
    });

    this.setState({ isLoadedMore: false });
  };
  handleSendToConversation = (messageInput) => {
    if (!this.hasTableOrderScope()) {
      return;
    }

    const { id, pin_id } = this.state.table_chair;
    if (id === undefined || pin_id === undefined) {
      return;
    }

    this.setState({ isCreatedAlert: false }, () => {
      this.socket.emit("message send conversation guest", {
        user_id: localStorage.getItem("guest_session_id"),
        message: messageInput,
        pin_id: pin_id,
        sender_id: localStorage.getItem("guest_session_id"),
        table_chair_id: id,
      });
    });
  };

  // UI
  isLoaded = (e) => {
    this.setState({ isFirstLoad: false });
  };
  handleToggleDetail = (e) => {
    const nextState = !this.state.activeTabDetail;
    this.setState(
      {
        activeTabDetail: nextState,
        isFirstLoad: this.state.activeTabDetail ? true : this.state.isFirstLoad,
        didUpdate: false,
      },
      () => {
        // Auto focus input when opening chat (nextState === true)
        if (nextState) {
          setTimeout(() => {
            if (this.chatInput) {
              this.chatInput.focus();
            }
          }, 300);
        }
      },
    );
  };
  handleChatInputPress = (e) => {
    if (e.key === "Enter") {
      let { messageInput } = this.state;
      if (messageInput.length > 0) {
        this.handleSendButtonClick();
      }
    }
  };
  handleChatInputChange = (e) => {
    this.setState({
      messageInput: e.target.value,
    });
  };
  handleSendButtonClick = (e) => {
    let { messageInput } = this.state;

    if (messageInput.length > 0) {
      this.handleSendToConversation(messageInput);

      this.setState({
        messageInput: "",
      });
    }
  };
  /**
   * End Message
   */

  incrementItem = (item) => {
    const targetIndex = this.findOrderIndexBySignature(this.state.orders, item);

    if (targetIndex < 0) return;

    this.setState((prev) => ({
      orders: prev.orders.map((order, index) =>
        index === targetIndex
          ? {
              ...order,
              count: order.count + 1,
              price: item.price,
              note: item.note,
              iceSelectedValue: item.iceSelectedValue,
              sugarSelectedValue: item.sugarSelectedValue,
              sizeSelectedId: item.sizeSelectedId,
              flavorSelectedId: item.flavorSelectedId,
              toppingSelectedId: item.toppingSelectedId,
            }
          : order,
      ),
    }));
  };

  decrementItem = (item) => {
    const targetIndex = this.findOrderIndexBySignature(this.state.orders, item);

    if (targetIndex < 0) return;

    const targetOrder = this.state.orders[targetIndex];
    if (!targetOrder || targetOrder.count <= 1) return;

    this.setState((prev) => ({
      orders: prev.orders.map((order, index) =>
        index === targetIndex
          ? {
              ...order,
              count: order.count - 1,
              price: item.price,
              note: item.note,
              iceSelectedValue: item.iceSelectedValue,
              sugarSelectedValue: item.sugarSelectedValue,
              sizeSelectedId: item.sizeSelectedId,
              flavorSelectedId: item.flavorSelectedId,
              toppingSelectedId: item.toppingSelectedId,
            }
          : order,
      ),
    }));
  };

  toggleOpenMenu = () => {
    this.setState((prev) => ({
      ...prev,
      openMenu: !this.state.openMenu,
    }));
  };

  handleCallService = () => {
    const { table_chair, company, callServiceCooldown } = this.state;

    if (!this.hasTableOrderScope() || !table_chair?.id) {
      NotificationManager.error(
        "Đơn online không hỗ trợ gọi thanh toán theo bàn",
        "Lỗi!",
        3000,
        null,
        null,
        "filled",
      );
      return;
    }

    // Check if still in cooldown
    if (callServiceCooldown > 0) {
      return;
    }

    if (!company || !company.user_id) {
      NotificationManager.error(
        "Không thể gọi thanh toán lúc này",
        "Lỗi!",
        3000,
        null,
        null,
        "filled",
      );
      return;
    }

    // Emit socket event to notify staff
    this.socket.emit("call-service", {
      user_id: company.user_id,
      table_identify: table_chair.identify,
      table_id: table_chair.id,
    });

    NotificationManager.success(
      "Đã gửi yêu cầu gọi thanh toán!",
      "Thành công",
      3000,
      null,
      null,
      "filled",
    );

    // Start 10 second cooldown
    this.setState({ callServiceCooldown: 10 });

    // Countdown timer
    this.callServiceTimer = setInterval(() => {
      this.setState((prev) => {
        const newCooldown = prev.callServiceCooldown - 1;
        if (newCooldown <= 0) {
          clearInterval(this.callServiceTimer);
          return { callServiceCooldown: 0 };
        }
        return { callServiceCooldown: newCooldown };
      });
    }, 1000);
  };

  handleCallBell = () => {
    const { table_chair, company, callBellCooldown } = this.state;

    if (!this.hasTableOrderScope() || !table_chair?.id) {
      NotificationManager.error(
        "Đơn online không hỗ trợ gọi phục vụ theo bàn",
        "Lỗi!",
        3000,
        null,
        null,
        "filled",
      );
      return;
    }

    // Check if still in cooldown
    if (callBellCooldown > 0) {
      return;
    }

    if (!company || !company.user_id) {
      NotificationManager.error(
        "Không thể gọi phục vụ lúc này",
        "Lỗi!",
        3000,
        null,
        null,
        "filled",
      );
      return;
    }

    // Emit socket event to notify staff
    this.socket.emit("call-bell", {
      user_id: company.user_id,
      table_identify: table_chair.identify,
      table_id: table_chair.id,
    });

    NotificationManager.success(
      "Đã gửi yêu cầu gọi phục vụ!",
      "Thành công",
      3000,
      null,
      null,
      "filled",
    );

    // Start 10 second cooldown
    this.setState({ callBellCooldown: 10 });

    // Countdown timer
    this.callBellTimer = setInterval(() => {
      this.setState((prev) => {
        const newCooldown = prev.callBellCooldown - 1;
        if (newCooldown <= 0) {
          clearInterval(this.callBellTimer);
          return { callBellCooldown: 0 };
        }
        return { callBellCooldown: newCooldown };
      });
    }, 1000);
  };

  toggleOrderBill = () => {
    this.setState((prev) => ({
      ...prev,
      openPayBill: !this.state.openPayBill,
    }));
  };

  handleCustomerBankChange = (selectedOption) => {
    this.setState({ selectedCustomerBank: selectedOption });
  };

  handleCustomerBankPayment = () => {
    const { selectedCustomerBank, ordersFiltered } = this.state;
    const bankPay = localStorage.getItem("bankPay");
    const numberPay = localStorage.getItem("numberPay");
    const namePay = localStorage.getItem("namePay");

    if (!selectedCustomerBank) {
      NotificationManager.error(
        "Vui lòng chọn ngân hàng của bạn!",
        "Lỗi!",
        3000,
        null,
        null,
        "filled",
      );
      return;
    }

    if (!bankPay || bankPay === "null" || !numberPay || numberPay === "null") {
      NotificationManager.error(
        "Thông tin thanh toán của cửa hàng chưa được cài đặt!",
        "Lỗi!",
        3000,
        null,
        null,
        "filled",
      );
      return;
    }

    // Calculate total price
    const total_price = this.getTotalPrice(ordersFiltered);

    // Build the VietQR deep link URL based on customer's bank
    // Format: https://dl.vietqr.io/pay?app={customerBankCode}&ba={shopBankCode}-{shopAccountNumber}@{shopBankName}&am={amount}&tn={description}
    const customerBankCode = this.getBankCode(selectedCustomerBank.value);
    const shopBankCode = GetBank(bankPay)?.label?.split(" - ")[0] || "";
    const description = encodeURIComponent(`Thanh toan don hang`);

    // VietQR deep link format for customer's banking app
    const vietQRUrl = `https://dl.vietqr.io/pay?app=${customerBankCode}&ba=${numberPay}@${bankPay}&am=${total_price}&tn=${description}`;

    // Open the deep link in a new window/tab
    window.open(vietQRUrl, "_blank");

    NotificationManager.success(
      "Đang chuyển đến ứng dụng ngân hàng của bạn...",
      "Thông báo",
      3000,
      null,
      null,
      "filled",
    );
  };

  getBankCode = (bankValue) => {
    // Map bank value to VietQR bank code
    const bankCodeMap = {
      970436: "VCB",
      970415: "CTG",
      970418: "BIDV",
      970405: "AGRIBANK",
      970422: "MB",
      970407: "TCB",
      970448: "OCB",
      970416: "ACB",
      970432: "VPB",
      970423: "TPB",
      970403: "STB",
      970437: "HDB",
      970454: "VCCB",
      970429: "SCB",
      970441: "VIB",
      970443: "SHB",
      970431: "EIB",
      970426: "MSB",
      546034: "CAKE",
      546035: "UBANK",
      963388: "TIMO",
      971005: "VIETTELMONEY",
      971011: "VNPTMONEY",
      970400: "SGB",
      970409: "BAB",
      970412: "PVCB",
      970414: "OCEANBANK",
      970419: "NCB",
      970424: "SHBVN",
      970425: "ABB",
      970427: "VAB",
      970428: "NAB",
      970430: "PGB",
      970433: "VIETBANK",
      970438: "BVB",
      970440: "SEAB",
      970446: "COOPBANK",
      970449: "LPB",
      970452: "KLB",
      668888: "KBANK",
      970458: "UOB",
      970410: "SCVN",
      970439: "PBVN",
      801011: "NHB",
      970434: "IVB",
      970456: "IBKHCM",
      970455: "IBKHN",
      970421: "VRB",
      970457: "WVN",
      970462: "KBHN",
      970463: "KBHCM",
      458761: "HSBC",
      970442: "HLBVN",
      970408: "GPB",
      970406: "DAB",
      796500: "DBS",
      422589: "CIMB",
      970444: "CBB",
      533948: "CITIBANK",
      970466: "KEBHANA",
      970467: "KEBHANAHN",
      977777: "MAFC",
      999888: "VBSP",
    };
    return bankCodeMap[bankValue] || "VCB";
  };

  getOriginalPrice = (item) => {
    if (!item) return 0;

    return item.price * 1;
  };

  getTotalPrice = (items) => {
    if (!items || !items.length) return 0;

    const cost = items.reduce((total, item) => {
      return total + item.price * item.count;
    }, 0);

    return cost;
  };

  tooltipOpen = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  };

  getIpAddress = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/getIPAddress"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        console.log("IP: ", res.data);
        return res.data;
      })
      .then((data) => {
        this.setState({
          ipAddress: data,
        });
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
      });
  };

  render() {
    const {
      items,
      openMenu,
      openPayBill,
      dropDown,
      // selectedOrderOption,
      // orderOptions,
      orders,
      ordersFiltered,
      modalOrderOpen,
      company,
      isVerify,
      startAt,
      reMount,
      activeTabDetail,
      messageInput,
      conversationData,
      isLoadedMore,
      isEndMessagesData,
      isFirstLoad,
      customer_phone,
      customer_name,
      customer_delivery_time,
      customer_address,
      customerFormErrors,
      callServiceCooldown,
      callBellCooldown,
    } = this.state;

    // console.log('conversationDataGuest: ', conversationData);
    // console.log('orders: ', orders);
    // console.log('menu: ', this.state.menu);

    // console.log(
    //     'consolidatedOrders: ',
    //     this.consolidateOrders(ordersFiltered)
    // );
    let total_price = this.getTotalPrice(ordersFiltered);

    const namePay = localStorage.getItem("namePay");
    const numberPay = localStorage.getItem("numberPay");
    const bankPay = localStorage.getItem("bankPay");
    const qrPayImage = localStorage.getItem("qrPayImage");
    const isRemoteOrder = !this.hasTableOrderScope();

    return !this.state.isLoading ? (
      <div className="loading" />
    ) : (
      <div className="menu-guest">
        {openPayBill === true ? (
          <Colxx xxs="12" className="mb-4">
            <div
              className="d-flex align-items-center table-modal-header center mt-3 mb-3"
              onClick={this.toggleOrderBill}
            >
              <div className="float-left">
                <i className="simple-icon-arrow-left p-2 cursor-pointer" />
              </div>
              <h3 className="m-0-auto pad-l-25px pad-10px text-uppercase">
                <IntlMessages id="guest.invoice" />
              </h3>
            </div>
            <Card
              className={classnames("mb-3 invoice-contents p-2", {
                // card: !cardWrapper,
              })}
              // className='mb-5 invoice-contents'
            >
              <CardBody className="d-flex flex-column justify-content-between p-2">
                <div
                  // className='d-flex flex-column'
                  className={classnames(
                    "d-flex flex-column align-self-center order-invoice p-0 w-100",
                    {
                      // 'card-body': !cardWrapper,
                    },
                  )}
                >
                  <Table borderless>
                    <thead>
                      <style>{`@media print {.no-print{display: none;}}`}</style>
                      <tr>
                        <th className="text-muted pd-light text-extra-small mb-2 text-to-print">
                          #
                        </th>
                        <th className="text-left pd-light text-muted text-extra-small mb-2 text-to-print">
                          <IntlMessages id="guest.product" />
                        </th>
                        <th className="text-center pd-light text-muted text-extra-small mb-2 text-to-print">
                          <IntlMessages id="guest.price" />
                        </th>
                        <th className="text-right pd-light text-muted text-extra-small mb-2 text-to-print">
                          <IntlMessages id="guest.total" />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {ordersFiltered.length &&
                        ordersFiltered.map((item) => (
                          <React.Fragment key={item.id}>
                            <tr>
                              <td className="text-to-print pd-light text-primary text-center">
                                {item.count}x
                              </td>
                              <td className="text-to-print pd-light text-left">
                                {item.product.name}
                              </td>
                              <td className="text-to-print text-center pd-light">
                                {AddCommaNumber(this.getOriginalPrice(item))}
                              </td>
                              <td className="text-right text-to-print pd-light">
                                {AddCommaNumber(
                                  Number(item.price) * item.count,
                                )}
                              </td>
                            </tr>
                            {/* {(discount &&
                                                        discount.saved &&
                                                        discount.note) ||
                                                    (item.discount &&
                                                        item.discount.note) ? (
                                                        <tr>
                                                            <td
                                                                className='discount-note no-print pd-light'
                                                                colSpan='4'
                                                            >
                                                                {`* ${GetDiscountOrderNote(
                                                                    discount,
                                                                    item
                                                                )}`}
                                                            </td>
                                                        </tr>
                                                    ) : null} */}
                          </React.Fragment>
                        ))}
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex flex-column">
                  <Table borderless className="d-flex justify-content-end mb-2">
                    <tbody>
                      <tr className="font-weight-bold">
                        <td className="text-semi-muted text-to-print text-right pd-light mb-3">
                          <IntlMessages id="guest.total-amount" />:
                        </td>
                        <td className="text-right text-bold text-to-print pd-light font-weight-bold">
                          {AddCommaNumber(total_price)}
                        </td>
                      </tr>
                      {/* {(discount &&
                                            discount.saved &&
                                            discount.value &&
                                            discount.type) ||
                                        find_item_discount ? (
                                            <tr>
                                                <td className='text-semi-muted text-to-print text-right pd-light'>
                                                    Chiết khấu:
                                                </td>
                                                <td className='text-right text-to-print pd-light'>
                                                    {AddCommaNumber(
                                                        total_discount_price
                                                    )}
                                                </td>
                                            </tr>
                                        ) : null}
                                        {(tax_fee &&
                                            tax_fee.saved &&
                                            tax_fee.value &&
                                            tax_fee.type) ||
                                        find_item_tax_fee ? (
                                            <tr>
                                                <td className='text-semi-muted text-to-print text-right pd-light'>
                                                    Thuế:
                                                </td>
                                                <td className='text-right text-to-print pd-light'>
                                                    {AddCommaNumber(
                                                        total_tax_fee_price
                                                    )}
                                                </td>
                                            </tr>
                                        ) : null}
                                        {(fee_other &&
                                            fee_other.saved &&
                                            fee_other.value &&
                                            fee_other.type) ||
                                        find_item_fee_other ? (
                                            <tr>
                                                <td className='text-semi-muted text-to-print text-right pd-light'>
                                                    Phụ phí:
                                                </td>
                                                <td className='text-right text-to-print pd-light'>
                                                    {AddCommaNumber(
                                                        total_fee_other_price
                                                    )}
                                                </td>
                                            </tr>
                                        ) : null}
                                        {(discount &&
                                            discount.saved &&
                                            discount.value &&
                                            discount.type) ||
                                        find_item_discount ||
                                        (tax_fee &&
                                            tax_fee.saved &&
                                            tax_fee.value &&
                                            tax_fee.type) ||
                                        find_item_tax_fee ||
                                        (fee_other &&
                                            fee_other.saved &&
                                            fee_other.value &&
                                            fee_other.type) ||
                                        find_item_fee_other ? (
                                            <tr className='font-weight-bold'>
                                                <td className='text-semi-muted text-to-print text-right pd-light'>
                                                    Số tiền thanh toán:
                                                </td>
                                                <td className='text-right text-bold text-to-print pd-light font-weight-bold'>
                                                    {AddCommaNumber(
                                                        total_payment_price
                                                    )}
                                                </td>
                                            </tr>
                                        ) : null} */}
                    </tbody>
                  </Table>

                  {/* <div className='border-bottom mb-3' />
                                <p className='text-muted text-small text-center mb-1'>
                                    Chân thành cảm ơn quý khách!{' '}
                                </p>
                                <span className='text-small text-center'>
                                    Bản quyền thuộc vmass.vn.
                                </span> */}
                </div>
              </CardBody>
            </Card>
            {/* Payment Info Card - QR Code and Bank Details */}
            {namePay === "null" ||
            numberPay === "null" ||
            bankPay === "null" ||
            !namePay ||
            !numberPay ||
            !bankPay ? null : (
              <Card className="mb-3">
                <div className="d-flex align-items-center p-3">
                  <Colxx xxs="3" className="pl-0 text-center">
                    {bankPay && numberPay ? (
                      <SingleLightbox
                        thumb={getQrPayWithCash(
                          bankPay,
                          numberPay,
                          total_price,
                        )}
                        large={getQrPayWithCash(
                          bankPay,
                          numberPay,
                          total_price,
                        )}
                        className="img-thumbnail card-img-bill"
                      />
                    ) : null}
                  </Colxx>
                  <Colxx xxs="9" className="text-left p-0">
                    <p className="mb-1 font-weight-bold">{namePay}</p>
                    <p className="mb-1">{numberPay}</p>
                    <p className="mb-1 text-muted">
                      {GetBank(bankPay)?.label?.split(" - ")[0] ||
                        GetBank(bankPay).label}
                    </p>
                  </Colxx>
                </div>
              </Card>
            )}

            <div className="order-btn-preview">
              <Colxx xxs="12" className="p-0">
                <div className="d-flex gap-2">
                  <div style={{ flex: 1 }}>
                    <Select
                      className="react-select mb-2 select-bank"
                      classNamePrefix="react-select"
                      menuPlacement="top"
                      options={[
                        { label: "Vietcombank", value: 970436 },
                        { label: "VietinBank", value: 970415 },
                        { label: "BIDV", value: 970418 },
                        { label: "Agribank", value: 970405 },
                        { label: "MBBank", value: 970422 },
                        { label: "Techcombank", value: 970407 },
                        { label: "OCB", value: 970448 },
                        { label: "ACB", value: 970416 },
                        { label: "VPBank", value: 970432 },
                        { label: "TPBank", value: 970423 },
                        { label: "Sacombank", value: 970403 },
                        { label: "HDBank", value: 970437 },
                        { label: "VietCapitalBank", value: 970454 },
                        { label: "SCB", value: 970429 },
                        { label: "VIB", value: 970441 },
                        { label: "SHB", value: 970443 },
                        { label: "Eximbank", value: 970431 },
                        { label: "MSB", value: 970426 },
                        { label: "CAKE", value: 546034 },
                        { label: "Ubank", value: 546035 },
                        { label: "Timo", value: 963388 },
                        { label: "ViettelMoney", value: 971005 },
                        { label: "VNPTMoney", value: 971011 },
                        { label: "SaigonBank", value: 970400 },
                        { label: "BacABank", value: 970409 },
                        { label: "PVcomBank", value: 970412 },
                        { label: "OceanBank", value: 970414 },
                        { label: "NCB", value: 970419 },
                        { label: "ShinhanBank", value: 970424 },
                        { label: "ABBANK", value: 970425 },
                        { label: "VietABank", value: 970427 },
                        { label: "NamABank", value: 970428 },
                        { label: "PGBank", value: 970430 },
                        { label: "VietBank", value: 970433 },
                        { label: "BaoVietBank", value: 970438 },
                        { label: "SeABank", value: 970440 },
                        { label: "COOPBANK", value: 970446 },
                        { label: "LienVietPostBank", value: 970449 },
                        { label: "KienLongBank", value: 970452 },
                        { label: "KBank", value: 668888 },
                        { label: "UOB", value: 970458 },
                        { label: "StandardChartered", value: 970410 },
                        { label: "PublicBank", value: 970439 },
                        { label: "Nonghyup", value: 801011 },
                        { label: "IndovinaBank", value: 970434 },
                        { label: "IBKHCM", value: 970456 },
                        { label: "IBKHN", value: 970455 },
                        { label: "VRB", value: 970421 },
                        { label: "Woori", value: 970457 },
                        { label: "KookminHN", value: 970462 },
                        { label: "KookminHCM", value: 970463 },
                        { label: "HSBC", value: 458761 },
                        { label: "HongLeong", value: 970442 },
                        { label: "GPBank", value: 970408 },
                        { label: "DongABank", value: 970406 },
                        { label: "DBSBank", value: 796500 },
                        { label: "CIMB", value: 422589 },
                        { label: "CBBank", value: 970444 },
                        { label: "Citibank", value: 533948 },
                        { label: "KEBHanaHCM", value: 970466 },
                        { label: "KEBHANAHN", value: 970467 },
                        { label: "MAFC", value: 977777 },
                        { label: "VBSP", value: 999888 },
                      ]}
                      value={this.state.selectedCustomerBank}
                      onChange={this.handleCustomerBankChange}
                      // styles={{
                      //     control: (base) => ({
                      //         ...base,
                      //         border: 'none',
                      //         boxShadow: 'none',
                      //         background: 'transparent',
                      //         minHeight: '32px',
                      //     }),
                      //     valueContainer: (base) => ({
                      //         ...base,
                      //         padding: '0 8px',
                      //     }),
                      //     indicatorSeparator: () => ({
                      //         display: 'none',
                      //     }),
                      // }}
                    />
                    <Button
                      color="primary"
                      className="top-right-button "
                      onClick={this.handleCustomerBankPayment}
                      block
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <i className="simple-icon-credit-card mr-1" />
                        <IntlMessages id="guest.payment" />
                      </div>
                    </Button>
                  </div>
                  {!isRemoteOrder && (
                    <div
                      style={{
                        flex: 1,
                        marginLeft: "0.5rem",
                        marginTop: "auto",
                      }}
                    >
                      <div
                        style={{
                          height: "34px",
                          marginBottom: "0.5rem",
                        }}
                      ></div>
                      <Button
                        color={callServiceCooldown > 0 ? "secondary" : "danger"}
                        className="top-right-button"
                        onClick={this.handleCallService}
                        disabled={callServiceCooldown > 0}
                        block
                      >
                        <span>
                          {callServiceCooldown > 0 ? (
                            <IntlMessages
                              id="guest.call-service-cooldown"
                              values={{ seconds: callServiceCooldown }}
                            />
                          ) : (
                            <IntlMessages id="guest.call-service" />
                          )}
                        </span>
                      </Button>
                    </div>
                  )}
                </div>
              </Colxx>
            </div>
          </Colxx>
        ) : (
          <Fragment>
            {/* MESSAGE */}
            {!isRemoteOrder && (
              <div className="message-guest-container">
                <div
                  className={classnames("message-screen-detail", {
                    active: activeTabDetail,
                  })}
                >
                  <Row className="custom-row-no-margin">
                    <Colxx
                      xxs="12"
                      md="12"
                      xl="12"
                      className="col-left custom-col-12-no-padding"
                    >
                      <Card
                        className="position-relative"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: "100vh", // Force full height
                          overflow: "hidden",
                        }}
                      >
                        {/* Flex Header */}
                        <div
                          className="message-screen-detail__header"
                          style={{
                            flex: "0 0 auto",
                            zIndex: 1001,
                            background: "#fff",
                          }}
                        >
                          <span
                            className="icon"
                            onClick={this.handleToggleDetail}
                          >
                            <i className="iconsminds-to-left" />
                          </span>
                          <span className="text">
                            {company.companyName != "null"
                              ? company.companyName
                              : ""}
                          </span>
                        </div>
                        <div
                          style={{
                            flex: "0 0 auto",
                            height: "1px",
                            backgroundColor: "#d7d7d7", // Darker gray for visibility
                            width: "100%",
                            margin: "0",
                          }}
                        />
                        {/* Flex Content (Scrollable) */}
                        <div
                          className="message-screen-detail__content"
                          style={{
                            flex: "1 1 auto",
                            overflow: "hidden",
                            position: "relative",
                            paddingBottom: "40px",
                            height: "auto", // Let flex handle it
                          }}
                        >
                          <PerfectScrollbar
                            onYReachStart={(container) => {
                              if (!isEndMessagesData)
                                container.scrollTop = 63 * 8 - 33; // height * size - (height / 2)

                              if (
                                isLoadedMore &&
                                !isEndMessagesData &&
                                !isFirstLoad
                              ) {
                                setTimeout(() => {
                                  this.handleGetConversation();
                                }, 1);
                              }

                              if (isFirstLoad) {
                                this.isLoaded();
                              }
                            }}
                            ref={(ref) => {
                              this._scrollBarRef = ref;
                            }}
                            containerRef={(ref) => {}}
                            options={{
                              suppressScrollX: true,
                              wheelPropagation: true,
                            }}
                          >
                            <div className="mb-3" />
                            {!conversationData ||
                            conversationData.length === 0 ? (
                              <div
                                className="d-flex flex-column justify-content-center align-items-center h-100 text-muted"
                                style={{ minHeight: "300px" }}
                              >
                                <i
                                  className="simple-icon-bubbles mb-3"
                                  style={{ fontSize: "3rem", opacity: 0.5 }}
                                />
                                <p className="mb-0">
                                  Xin chào, quý khách cần hỗ trợ gì ạ?
                                </p>
                              </div>
                            ) : (
                              conversationData.map((item, idx) => (
                                <div
                                  key={idx}
                                  ref={`message_guest_${idx}`}
                                  className="mb-3"
                                >
                                  <MessageCard
                                    idx={idx}
                                    company={company}
                                    item={item}
                                    pin_id={this.state.table_chair.pin_id}
                                  />
                                </div>
                              ))
                            )}
                          </PerfectScrollbar>
                        </div>
                        {/* Flex Footer (Input) */}
                        <div
                          className="message-screen-detail__container__submit"
                          style={{
                            flex: "0 0 auto",
                            background: "#fff",
                            padding: "10px",
                            borderTop: "1px solid #f3f3f3",
                            position: "relative", // Reset absolute
                            bottom: "auto",
                            left: "auto",
                            right: "auto",
                            width: "100%",
                          }}
                        >
                          <div className="message-screen-detail__submit d-flex justify-content-between align-items-center">
                            <Input
                              innerRef={(input) => {
                                this.chatInput = input;
                              }}
                              autoFocus={true}
                              className="form-control flex-grow-1"
                              type="text"
                              placeholder={"Viết tin nhắn"}
                              value={messageInput}
                              onKeyPress={(e) => this.handleChatInputPress(e)}
                              onChange={(e) => this.handleChatInputChange(e)}
                            />
                            <div>
                              <Button
                                color="primary"
                                className="icon-button large ml-1"
                                onClick={() => this.handleSendButtonClick()}
                              >
                                <i className="simple-icon-arrow-right" />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Colxx>
                  </Row>
                </div>
              </div>
            )}
            {/* END MESSAGE */}

            <SingleLightbox
              thumb={getCompanyImage(company)}
              large={getCompanyImage(company)}
              className="responsive border-0 card-img-top mb-3 mxh-700"
              fallback={DEFAULT_COVER}
            />
            {/* CONTENT */}
            <div
              className={classnames(
                "disable-text-selection smooth-scroll-container p-0-2",
                {
                  softhide: !isRemoteOrder && activeTabDetail,
                },
              )}
            >
              <Row className="custom-row-no-margin">
                <Colxx
                  xxs="12"
                  md="12"
                  xl="12"
                  className="col-left custom-col-12-no-padding"
                >
                  <div className="mb-3" id="item_home">
                    <div>
                      <div className="mb-3">
                        <div className="menu-guest-header align-items-center">
                          <h5 className="card-title">
                            {company.companyName ? company.companyName : ""}
                          </h5>
                          {!isRemoteOrder && (
                            <div
                              onClick={this.handleToggleDetail}
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                zIndex: 10,
                                padding: "8px",
                                border: "1px dotted #2499e3", // Primary color dotted border
                                borderRadius: "10px",
                                width: "40px",
                                height: "40px",
                              }}
                            >
                              <i
                                className="iconsminds-speach-bubble-8"
                                style={{ fontSize: "18px" }}
                              />
                            </div>
                          )}
                        </div>
                        <p>
                          {company.companyAddress ? company.companyAddress : ""}
                        </p>
                      </div>
                      <Separator className="mb-3" />
                      {ordersFiltered?.length && openMenu === false ? (
                        <div className="table-modal-header center mt-3 mb-3">
                          <h3 className="m-0-auto pad-l-25px pad-10px text-uppercase">
                            Danh sách các món đã đặt!
                          </h3>
                        </div>
                      ) : (
                        <PageHeading
                          heading="Menu"
                          onSearchKey={this.onSearchKey}
                          onSearchChange={this.onSearchChange}
                          // changeOrderBy={this.changeOrderBy}
                          // selectedOrderOption={selectedOrderOption}
                          // orderOptions={orderOptions}
                        />
                      )}
                    </div>
                  </div>
                </Colxx>
              </Row>
              {ordersFiltered?.length && openMenu === false ? (
                <>
                  <div className="disable-text-selection smooth-scroll-container custom-row-no-margin-tlr-80">
                    {ordersFiltered.map((order) => {
                      const toppings = order.topping.split("|");
                      return (
                        <Card className="flex-row mb-3" key={order.id}>
                          <section className="d-block position-relative">
                            <ProductImage
                              image={order.product.image}
                              alt={order.name}
                              fnbType={order.product.fnb_type}
                              className="list-thumbnail responsive border-0 m-1"
                              iconSize="40px"
                            />
                            <Badge
                              className="position-absolute badge-top-right"
                              color={
                                order.status.uuid === STATUS.CREATED
                                  ? "primary"
                                  : order.status.uuid === STATUS.CLOSED
                                    ? "danger"
                                    : order.status.uuid === STATUS.PENDING
                                      ? "info"
                                      : order.status.uuid === STATUS.COMPLETED
                                        ? "success"
                                        : "danger"
                              }
                              pill
                            >
                              {order.status.name}
                            </Badge>
                          </section>
                          <div className="w-100 d-flex flex-column justify-content-between min-width-zero p-2">
                            <div className="d-flex justify-content-between">
                              <div className="list-item-heading mb-1 truncate">
                                x{order.count} {order.product.name}
                              </div>
                              <div>{order.time}</div>
                            </div>
                            <div className="w-100">
                              {order.size === "" ||
                              order.size.split(",")[1] === "0" ? null : (
                                <Badge className="mr-1 mt-1" color="warning">
                                  {order.size.split(",")[0]}
                                </Badge>
                              )}
                              {order.flavor ? (
                                <Badge className="mr-1 mt-1" color="info">
                                  Vị: {order.flavor.split(",")[0]}
                                </Badge>
                              ) : null}
                              {order.ice === "" ||
                              order.ice === "100" ? null : (
                                <Badge className="mr-1 mt-1" color="primary">
                                  Đá: {order.ice}%
                                </Badge>
                              )}
                              {order.sugar === "" ||
                              order.sugar === "100" ? null : (
                                <Badge className="mr-1 mt-1" color="info">
                                  Độ ngọt: {order.sugar}%
                                </Badge>
                              )}
                              {order.topping === "" ||
                              order.topping.split(",")[1] === "0"
                                ? null
                                : toppings.map((_topping, idx) => (
                                    <Badge
                                      color="success"
                                      className="mr-1 mt-1"
                                      key={idx}
                                    >
                                      {_topping.split(",")[0]}
                                    </Badge>
                                  ))}
                            </div>
                          </div>
                        </Card>
                      );
                    })}
                  </div>
                  <div className="d-flex order-btn-preview">
                    <Colxx xxs="5" className="p-0 pr-1">
                      <Button
                        color="danger"
                        className={`top-right-button ${
                          openPayBill
                            ? "button-transition clicked"
                            : "button-transition"
                        }`}
                        onClick={this.toggleOrderBill}
                        block
                      >
                        <span>Thanh toán</span>
                      </Button>
                    </Colxx>
                    <Colxx xxs="5" className="p-0 pr-1">
                      <Button
                        color="info"
                        className="top-right-button"
                        onClick={this.toggleOpenMenu}
                        block
                      >
                        <span>Thêm món</span>
                      </Button>
                    </Colxx>
                    <Colxx xxs="2" className="p-0">
                      <Button
                        color={callBellCooldown > 0 ? "secondary" : "warning"}
                        className="top-right-button"
                        onClick={this.handleCallBell}
                        disabled={callBellCooldown > 0}
                        block
                      >
                        {callBellCooldown > 0 ? (
                          <span>{callBellCooldown}s</span>
                        ) : (
                          <i className="iconsminds-bell" />
                        )}
                      </Button>
                    </Colxx>
                    {/* <Colxx xxs='2' className='p-0'>
                                            <ButtonDropdown
                                                direction='up'
                                                isOpen={dropDown}
                                                toggle={() => {
                                                    this.setState({
                                                        dropDown:
                                                            !this.state
                                                                .dropDown,
                                                    });
                                                }}
                                            >
                                                <DropdownToggle
                                                    className='w-100'
                                                    caret
                                                    color='info'
                                                    direction='up'
                                                >
                                                    ...
                                                </DropdownToggle>
                                                <DropdownMenu
                                                    right
                                                    className='p-3 text-center'
                                                >
                                                    <Button
                                                        color='danger'
                                                        className='mb-2 mx-auto'
                                                    >
                                                        Trả món
                                                    </Button>
                                                    <Button
                                                        color='warning'
                                                        className='mb-2 mx-auto'
                                                    >
                                                        Gọi phục vụ
                                                    </Button>
                                                </DropdownMenu>
                                            </ButtonDropdown>
                                        </Colxx> */}
                  </div>
                </>
              ) : (
                <>
                  {items.length ? (
                    <div id="nav_bar" className="sticky mb-2">
                      <GlideComponentCustom
                        settings={{
                          startAt: startAt,
                          gap: 5,
                          perView: 3,
                          type: "slider",
                          breakpoints: {
                            850: { perView: 3 },
                            1200: { perView: 3 },
                            1900: { perView: 3 },
                          },
                          hideNav: true,
                          reMount: reMount,
                        }}
                      >
                        {this.renderCategories()}
                      </GlideComponentCustom>
                    </div>
                  ) : null}
                  <Row className="custom-row-no-margin-tlr mr-bt-50px">
                    <Colxx
                      xxs="12"
                      md="12"
                      xl="12"
                      className="col-left custom-col-12-no-padding"
                    >
                      {items.length
                        ? items.map((categories, index) => {
                            return categories.data.length ? (
                              <React.Fragment key={categories.id}>
                                <div
                                  id={"item_" + index}
                                  className="mb-3 pt-30px custom-shadow"
                                >
                                  <div>
                                    <CardTitle>{categories.name}</CardTitle>
                                    {categories.data.length &&
                                      categories.data.map((product) => {
                                        return (
                                          <ThumbListViewMenuGuest
                                            key={product.id}
                                            product={product}
                                            order={this.getOrder(product.id)}
                                            sub={this.sub}
                                            plus={this.plus}
                                            change={this.change}
                                            isVerify={isVerify}
                                            onToggleDetail={this.onToggleDetail}
                                            onAddToCartWithQuantity={
                                              this.addToCartWithQuantity
                                            }
                                            detailDisplay={
                                              product.detailDisplay
                                            }
                                            orderDisplay={product.orderDisplay}
                                            sizeSelectedId={
                                              product.sizeSelectedId
                                            }
                                            toppingSelectedId={
                                              product.toppingSelectedId
                                            }
                                            toppingSelectedIdLen={
                                              product.toppingSelectedId.length
                                            }
                                            iceSelectedValue={
                                              product.iceSelectedValue
                                            }
                                            sugarSelectedValue={
                                              product.sugarSelectedValue
                                            }
                                            showNote={product.showNote}
                                          />
                                        );
                                      })}
                                  </div>
                                </div>
                              </React.Fragment>
                            ) : null;
                          })
                        : null}
                    </Colxx>{" "}
                    <ProductOrderModalMenuGuest
                      isOpen={modalOrderOpen}
                      orders={orders}
                      menuItems={items}
                      incrementItem={this.incrementItem}
                      decrementItem={this.decrementItem}
                      phone={customer_phone}
                      name={customer_name}
                      deliveryTime={customer_delivery_time}
                      customerAddress={customer_address}
                      customerFormErrors={customerFormErrors}
                      isTableOrder={this.hasTableOrderScope()}
                      companyName={company.companyName}
                      onChange={this.onChange}
                      onToggleModal={this.toggleModalOrder}
                      onRemoveOrder={this.onRemoveOrder}
                      onToggleNote={this.onToggleNote}
                      handleSubmit={this.handleSubmit}
                      calTotalPrice={this.calTotalPrice}
                    />
                    <div
                      hidden={!this.state.orders.length}
                      className="order-btn-preview"
                    >
                      <Button
                        color="primary"
                        size="lg"
                        className="top-right-button pl-3"
                        onClick={this.toggleModalOrder}
                        block
                      >
                        <Row>
                          <Colxx xxs="5" md="5" xl="5">
                            <IntlMessages id="general.btn-order-preview" />{" "}
                          </Colxx>
                          <Colxx xxs="4" md="4" xl="4" className="fw-100">
                            {this.calcNumberOrder(orders)}{" "}
                            <IntlMessages id="guest.quantity" />{" "}
                          </Colxx>
                          <Colxx xxs="3" md="3" xl="3">
                            {AddCommaNumber(this.calTotalPrice(orders))}
                            <sup className="fz-sup">đ</sup>
                          </Colxx>
                        </Row>
                      </Button>
                    </div>
                    {/* Button to view ordered items when in menu mode - only show if no items in cart */}
                    {ordersFiltered?.length > 0 &&
                      !this.state.orders.length && (
                        <div className="order-btn-preview">
                          <Button
                            color="secondary"
                            size="lg"
                            className="top-right-button"
                            onClick={this.toggleOpenMenu}
                            block
                          >
                            <i className="simple-icon-list mr-2" />
                            <IntlMessages id="home.btn.order-preview" /> (
                            {ordersFiltered.length})
                          </Button>
                        </div>
                      )}
                  </Row>
                </>
              )}
            </div>
            {/* END CONTENT */}
          </Fragment>
        )}
      </div>
    );
  }
}
export default injectIntl(ProductGuest);
